import React from 'react';
import { Link } from 'react-router-dom';
import { Home, ArrowLeft, Search } from 'lucide-react';
import SEO from '../components/SEO';
import { Button } from '../components/ui/button';

/**
 * 404 page — rendered for:
 *   - unknown routes (catch-all in App.js)
 *   - deleted/invalid topic / vehicle / event / news IDs
 *
 * Google: served with meta robots=noindex,nofollow so it does not treat soft-404
 * SPA pages as valid pages. We can't return a real HTTP 404 without SSR, but
 * noindex is the officially supported SPA signal.
 */
export default function NotFoundPage({ title = 'Sayfa bulunamadı', message = 'Aradığınız sayfa taşınmış, silinmiş ya da adresi hatalı yazılmış olabilir.' }) {
  return (
    <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 py-20 text-center" data-testid="not-found-page">
      <SEO title="404 · Sayfa bulunamadı" description={message} noindex noSuffix />
      <div className="mx-auto w-20 h-20 rounded-2xl bg-emerald-50 text-emerald-600 flex items-center justify-center mb-6">
        <Search className="w-10 h-10" />
      </div>
      <h1 className="text-4xl sm:text-5xl font-extrabold text-slate-900 mb-3" style={{ fontFamily: 'Outfit, sans-serif' }}>404</h1>
      <h2 className="text-lg sm:text-xl font-semibold text-slate-700 mb-3">{title}</h2>
      <p className="text-slate-500 mb-8">{message}</p>
      <div className="flex items-center justify-center gap-3 flex-wrap">
        <Button asChild variant="outline" data-testid="not-found-back">
          <Link to="/forum"><ArrowLeft className="w-4 h-4 mr-2" />Foruma dön</Link>
        </Button>
        <Button asChild className="bg-emerald-600 hover:bg-emerald-700 text-white" data-testid="not-found-home">
          <Link to="/"><Home className="w-4 h-4 mr-2" />Ana sayfaya git</Link>
        </Button>
      </div>
    </div>
  );
}
